export const resolveAdminPageTitle = (pathname = "") => {
  const path = String(pathname || "")
    .replace(/^\/(?:super-admin|country-admin|venue-admin)(?=\/|$)/, "")
    .replace(/\/+$/, "") || "/dashboard";

  if (path === "/dashboard") return "Dashboard";
  if (path === "/banners") return "Banners";
  if (path === "/promo-codes") return "Promo Codes";
  if (path === "/games") return "Games";
  if (path === "/local-games") return "Local Games";
  if (path === "/push-notifications") return "Push Notifications";
  if (path === "/contact-enquiries") return "Contact Enquiries";

  if (path === "/block-slot") return "Availability";
  if (/^\/grounds\/[^/]+\/availability$/.test(path)) return "Availability";

  if (path === "/venues" || path.startsWith("/venues/")) return "Venues";
  if (path === "/users") return "Users";
  if (path === "/country-admins") return "Country Admins";
  if (path === "/admin-bookings") return "Admin Bookings";

  if (path === "/reservations" || path.startsWith("/reservations/")) {
    return "Bookings";
  }

  if (path === "/settlements" || path.startsWith("/settlements/")) {
    return "Settlements";
  }

  if (path === "/payments" || path.startsWith("/payments/")) {
    return "Payments";
  }

  if (path === "/commission") return "Commission";
  if (path === "/profile") return "Profile";

  return "";
};